import { render, staticRenderFns } from "./CardFeaturedMenuItem.vue?vue&type=template&id=3d68f4a3&scoped=true"
import script from "./CardFeaturedMenuItem.js?vue&type=script&lang=js&external"
export * from "./CardFeaturedMenuItem.js?vue&type=script&lang=js&external"
import style0 from "./CardFeaturedMenuItem.scss?vue&type=style&index=0&id=3d68f4a3&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d68f4a3",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotImage: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Image/Image.vue').default,HotLink: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Link/Link.vue').default})
